import React from "react";
import "./LeftSide.css";
import ItayAvatar from "../../Images/Fred3.jpg";
import UserAvatar from "../../Images/photoURL.png";
import MyLab from "../../Images/My-Lab.jpg";
import MyGroups from "../../Images/My-Groups.jpg";
import MyFriends from "../../Images/My-Friends.jpg";
import Sharing from "../../Images/Sharing-5.png";
import Discovery from "../../Images/Discovery.jpg";
import Experiments from "../../Images/experiments.png";
import Tools from "../../Images/tools.jpg";
import AITools from "../../Images/AITools.png";
import Admin from "../../Images/Admin.png";
import ConnectionSelect from "../Connections/ConnectionSelect";
import UserProfile from "../UserProfile/UserProfile";
import UserExperiments from "../Experiments/UserExperiment";
import ExperimentProjectSelect from "../Experiments/ExperimentProjectSelect";
import SharedDataProjectSelect from "../SharedData/SharedDataProjectSelect";
import MyLabSelect from "../MyLab/MyLabSelect";
import AllGroups from "../Groups/AllGroups";
import AIToolsPre from "../AITools/AIToolsPre";

import AdminGroupSelect from "../Admin/AdminGroupSelect";
import "../lib/RequireUser/index.css";
import { Link, useNavigate } from "react-router-dom";
import UpdateUserPhotoURL from "../UserProfile/UpdateUserPhotoURL";
import RetrieveUserProfile from "../UserProfile/RetrieveUserProfile";
import { doc, getDoc, getFirestore } from "firebase/firestore";
import { app } from "../lib/firebase";
import { GetDocID } from "../lib/controller";

function LeftSide() {
  // var photoURL = "";
  var bodyStyles = document.body.style;

  //GetDocID();
  const userID = localStorage.getItem("userUID");
  console.log("in left side and user id = ", userID);
  const userName = localStorage.getItem("userName");
  console.log("userName = ", localStorage.getItem("userName"));

  localStorage.setItem("lastGroupUsersLengthText", "0");

  const photoURL = localStorage.getItem("myPicture");

  //console.log("in left side and photoURL = ", photoURL);

  //Now to get the userProfile from firebase so we can extract the profile picture
  //we need to pass the userUID to a function and get the userProfile in return
  const photoRef = UpdateUserPhotoURL(photoURL);
  console.log(
    "in left side after UpdateUserPhotoURL and photoURL = ",
    photoRef
  );
  //userProfileRef = RetrieveUserProfile(userUID:)
  //userProfile = retrieveUserProfile (userUID);
  return (
    <div className="leftside_main">
      <div className="leftside">
        <a href="UserProfile">
          <img
            className="avatar2"
            src={photoRef}
            title="Edit your profile"
            style={{
              height: 50,
              width: 50,
              objectFit: "cover",
            }}
          />
          &emsp; {userName}
        </a>
      </div>
      <div className="leftside">
        <a href="MyLabSelect">
          <img src={MyLab} title="See who and what's in your lab" />
          &emsp;My Research Lab
        </a>
      </div>
      <div className="leftside">
        <a href="ExperimentProjectSelect">
          <img src={Experiments} title="Create or edit your experiments" />
          &emsp; Experiments
        </a>
      </div>
      <div className="leftside">
        <a href="AllGroups">
          <img src={MyGroups} title="Browse groups" />
          &emsp; Groups
        </a>
      </div>
      <div className="leftside">
        <a href="ConnectionSelect">
          <img src={MyFriends} title="Connection options" />
          &emsp; Connections
        </a>
      </div>
      <div className="leftside">
        <a href="SharedDataProjectSelect">
          <img src={Sharing} title="Browse and retrieve shared data" />
          &emsp; Shared Data
        </a>
      </div>
      <div className="leftside">
        <a href="#">
          <img
            src={Discovery}
            title="Discover new knowledge in existing data"
          />
          &emsp; Discovery
        </a>
      </div>

      <div className="leftside">
        <a href="AdminGroupSelect">
          <img src={Admin} title="Create and edit groups and projects" />
          &emsp; Administration
        </a>
      </div>
      <div className="leftside">
        <a href="AIToolsPre">
          <img src={AITools} title="Many AI tools to assist you" />
          &emsp; AI Tools
        </a>
      </div>
      <div className="leftside">
        <a href="#">
          <img src={Tools} title="Customize your environment" />
          &emsp; Customize
        </a>
      </div>
    </div>
  );
}

export default LeftSide;

//function getPropertyValue(arg0: string) {
//  throw new Error("Function not implemented.");
//}
//function getPropertyValue(arg0: string) {
//  throw new Error("Function not implemented.");
//}
